import React, {
  useCallback,
  useEffect,
  useState
} from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import axios from 'axios';
import { LogOut } from 'lucide-react';

import {
  SettingsProvider,
  useSettings
} from './contexts/SettingsContext';

import {
  WhatsAppProvider
} from './contexts/WhatsAppContext';

import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Clients from './pages/Clients';
import Processes from './pages/Processes';
import Financeiro from './pages/Financeiro';
import Remarketing from './pages/Remarketing';
import Promotions from './pages/Promotions';
import Contingency from './pages/Contingency';
import SettingsSafe from './pages/SettingsSafe';
import PainelUsers from './pages/PainelUsers';
import PartnerClients from './pages/PartnerClients';
import PartnerIntake from './pages/PartnerIntake';
import Login from './pages/Login';

axios.defaults.withCredentials = true;

const API = (
  process.env.REACT_APP_API_URL ||
  '/api'
).replace(/\/$/, '');

function Painel({ onLogout }) {
  const { darkMode } = useSettings();

  return (
    <div
      className={
        `flex min-h-screen ${
          darkMode
            ? 'bg-gray-900'
            : 'bg-gray-100'
        }`
      }
    >
      <Sidebar />

      <main className="flex-1 min-w-0">
        <div className="flex justify-end px-6 pt-4">
          <button
            onClick={onLogout}
            className={
              `${
                darkMode
                  ? 'bg-gray-800 border-gray-700 text-gray-300 hover:bg-gray-700'
                  : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50'
              } flex items-center gap-2 border rounded-lg px-3 py-2 text-sm font-medium`
            }
          >
            <LogOut size={17} />
            Sair
          </button>
        </div>

        <div className="p-6 pt-3">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/processes" element={<Processes />} />
              <Route path="/financial" element={<Financeiro />} />
              <Route path="/partners" element={<PartnerClients />} />
            <Route path="/remarketing" element={<Remarketing />} />
            <Route path="/promotions" element={<Promotions />} />
            <Route path="/contingency" element={<Contingency />} />
            <Route path="/settings" element={<SettingsSafe />} />
            <Route path="/settings/users" element={<PainelUsers />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

function AppContent() {
  const [usuario, setUsuario] =
    useState(null);

  const [verificando, setVerificando] =
    useState(true);

  const verificarSessao =
    useCallback(async () => {
      try {
        const response =
          await fetch(
            `${API}/auth/me`,
            {
              credentials: 'include'
            }
          );

        const data =
          await response.json();

        if (
          response.ok &&
          (
            data.authenticated === true ||
            Boolean(data.usuario)
          )
        ) {
          setUsuario(
            data.usuario
          );
        } else {
          setUsuario(null);
        }
      } catch (error) {
        setUsuario(null);
      } finally {
        setVerificando(false);
      }
    }, []);

  useEffect(() => {
    verificarSessao();
  }, [verificarSessao]);

  const sair = async () => {
    try {
      await fetch(
        `${API}/auth/logout`,
        {
          method: 'POST',
          credentials: 'include'
        }
      );
    } finally {
      setUsuario(null);
    }
  };

  if (verificando) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-4 border-gray-700 border-t-blue-500 animate-spin" />
      </div>
    );
  }

  if (!usuario) {
    return (
      <Login
        onLogin={data =>
          setUsuario(
            data.usuario
          )
        }
      />
    );
  }

  return (
    <Painel
      onLogout={sair}
    />
  );
}

function App() {
  return (
    <SettingsProvider>
      <WhatsAppProvider>
        <Router>
          <Routes>
            {/* LINK_DIRETO_LIMPA_NOME_V18 */}
              <Route
                path="/contratar-limpa-nome"
                element={
                  <PartnerIntake mode="direct" />
                }
              />

              <Route
                path="/parceiro/:token"
                element={
                  <PartnerIntake mode="partner" />
                }
              />
            <Route
              path="/*"
              element={<AppContent />}
            />
          </Routes>
        </Router>
      </WhatsAppProvider>
    </SettingsProvider>
  );
}

export default App;
